import React, { useEffect, useState } from 'react';
// $FlowFixMe
import { addDays, format } from 'date-fns';
import { credentials } from '@shootsta/client-auth';
import { Notification } from '../../../ui-kit';
import getSoonestProductToExpire from '../utils/getSoonestProductToExpire';
import getBannerType from '../utils/getBannerType';

export default function SubscriptionNotification({
  organisationId,
  getContractProducts,
  getOrgMembership,
  fullWidthStyle = false





}) {
  const [notificationProps, setNotificationProps] = useState({});

  const fetchData = async () => {
    // Don't show if this banner has been closed today
    if (localStorage.getItem('subscriptionBannerClosed') === format(new Date(), 'd LLL yyyy')) {
      return;
    }
    localStorage.removeItem('subscriptionBannerClosed');

    if (!credentials.get()) return;

    const { user } = credentials.get();

    if (!user) return;

    const { email } = user;

    if (organisationId && getOrgMembership) {
      const { data, error } = await getOrgMembership({ organisationId, email });

      if (error && !data) {return;}

      const membership = data && data.getOrgMembership;

      if (!membership || !membership.role) return;

      const { roleId } = membership.role;

      const {
        data: contractProductsData,
        error: contractProductsError
      } = await getContractProducts({ organisationId, roleId });

      if (contractProductsError && !contractProductsData) {return;}

      const { getContractProducts: productsArray } = contractProductsData;

      if (!productsArray) {return;}

      const soonestProductToExpire = getSoonestProductToExpire(productsArray);

      if (soonestProductToExpire === null) {
        return;
      }

      const expiryDate = soonestProductToExpire.daysToExpiry ?
      format(addDays(new Date(), soonestProductToExpire.daysToExpiry), 'd LLL yyyy') :
      '';

      const bannerType = getBannerType(
        soonestProductToExpire.daysToExpiry,
        soonestProductToExpire.status,
        expiryDate
      );

      const buildNotificationProps = bannerType && soonestProductToExpire ? {
        backgroundColour: bannerType.colour,
        text: bannerType.text,
        callToActionText: bannerType.callToActionText,
        isClosable: soonestProductToExpire.closable,
        onClickCloseBtn: () => {
          localStorage.setItem('subscriptionBannerClosed', format(new Date(), 'd LLL yyyy'));
        },
        fullWidthStyle
      } : {};

      setNotificationProps(buildNotificationProps);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <>
      {Object.entries(notificationProps).length > 0 ?
      <Notification {...notificationProps} /> :
      null}

    </>);

}